const React = require('react');
const PropTypes = require('prop-types');
const { formatText, FormattedText } = require('core/i18n').i18n;
const { PRODUCTION_ENVIRONMENT } = require('constants/index');
const { recordLinkCommonV2 } = require('commonsUtilities/tagging')
const { Button } = require('commonsComponents/button');
require('./Documentation.scss');

const Documentation = ({ fund }) => {
    const isNotProduction = __ENVIRONMENT__ !== PRODUCTION_ENVIRONMENT;
    const handleOpenDoc = (link, title) => {
        const elementNames = {
            'funds-dfiDocument': 'DFI',
            'funds-semestralDocument': 'economicReport',
            'funds-memory': 'marketingReport'
        };
        recordLinkCommonV2({
            categoriaEvento: 'broker/fund',
            accionEvento: 'funds documentation',
            etiquetaEvento: title,
            action: 'download',
            format: 'link',
            component: 'footer',
            element: elementNames[title] || title,
            pathname: link,
            eventCategory: 'broker/fund',
            eventAction: 'downloadLink',
            eventLabel: elementNames[title] || title,
        }, isNotProduction);
        window.open(link, '_blank');
    }
    return (
        <div className="footer__documentation">
            <div className="row">
                <div className="col-md-12 col-xs-12">
                    <p className="documentation__title">{formatText('fundsCard-documentationTitle')}</p>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12 col-xs-12">
                    <ul className="list-inline documentation__files">
                        {
                            fund.map((doc, i) => (
                                <li key={i}>
                                    <Button
                                        iconClass="icon icon-descargar"
                                        onClick={() => handleOpenDoc(doc.link, doc.titlePDF)}
                                        key={i.toString()}
                                    >
                                        <FormattedText value={doc.titlePDF} />
                                    </Button>
                                </li>
                            ))
                        }
                    </ul>
                </div>
            </div>
        </div>
    )
};


Documentation.propTypes = {
    fund: PropTypes.object.isRequired,
};


module.exports = Documentation;
